import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import { lacQueryKeys } from '../lacQueryKeys';

type UseLacTenantMonthlyCostsQueryOptions = {
  tenantName: string;
  fromMonth: string;
  toMonth: string;
  enabled?: boolean;
};

export function useLacTenantMonthlyCostsQuery({
  tenantName,
  fromMonth,
  toMonth,
  enabled = true,
}: UseLacTenantMonthlyCostsQueryOptions) {
  const trimmedTenantName = tenantName.trim();

  return useQuery({
    queryKey: lacQueryKeys.tenantMonthlyCosts(
      trimmedTenantName,
      fromMonth,
      toMonth,
    ),
    enabled:
      enabled &&
      trimmedTenantName.length > 0 &&
      fromMonth.length > 0 &&
      toMonth.length > 0,
    queryFn: () =>
      lacAnalyticsService.getMonthlyCosts(
        trimmedTenantName,
        fromMonth,
        toMonth,
      ),
  });
}
